import React from 'react';

type IconProps = {
  name: string;
  size?: number | string;
  color?: string;
  className?: string;
};

// @ts-ignore - webpack specific API
const icons = require.context('../../shared/assets/sprites/', false, /\.svg$/);

export const Icon: React.FC<IconProps> = ({
  name,
  size = 24,
  color = 'currentColor',
  className = '',
}) => {
  try {
    const iconPath = icons(`./${name}.svg`);
    const iconUrl = typeof iconPath === 'string' ? iconPath : iconPath.default;

    return (
      <img
        src={iconUrl}
        width={size}
        height={size}
        className={className}
        alt={name}
        style={{ filter: color !== 'currentColor' ? `invert(1)` : undefined }}
      />
    );
  } catch (error) {
    console.error(`Icon "${name}" not found`);
    return null;
  }
};
